import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-uparrows",
  "use": "icon-uparrows-usage",
  "viewBox": "0 0 11.5 18.562",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11.5 18.562\" id=\"icon-uparrows\">\r\n  <defs>\r\n    <style>\r\n      #icon-uparrows .cls-1 {\r\n        fill: #fff;\r\n        fill-rule: evenodd;\r\n      }\r\n    </style>\r\n  </defs>\r\n  <path id=\"icon-uparrows_形状_6\" data-name=\"形状 6\" class=\"cls-1\" d=\"M962.446,351.782V341.2h-4.2L964,333.213l5.757,7.985h-4.2v10.584h-3.116Z\" transform=\"translate(-958.25 -333.219)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/uparrows.svg
// module id = AqNM
// module chunks = 127